// Common gradients used throughout Picasso
export const GRADIENTS = {
  // Primary brand gradients
  picassoPrimary: 'linear-gradient(to right, #F69A7E 0%, #F69A7E 35%, #939BEC 100%)',
  picassoTitle: 'linear-gradient(to right, #F69A7E 10%, #939BEC 100%)',
  loginTitle: 'linear-gradient(to right, #F69A7E, #939BEC)',
  
  // Orange to purple variations
  orangeToPurple: 'linear-gradient(to right, #F39A81, #959BEA)',
  orangeToPurpleLight: 'linear-gradient(to right, #F39A81, #959BEA)',
  
  // Border gradients for components
  borderGradient: 'linear-gradient(white, white) padding-box, linear-gradient(to right, #F39A81, #959BEA) border-box',
  borderGradientAlt: 'linear-gradient(#FFFFFF, #FFFFFF) padding-box, linear-gradient(to right, #F39A81, #959BEA) border-box',
  borderGradientSimple: 'linear-gradient( #F39A81, #959BEA)',
  
  // Decorative line gradient
  decorativeLine: 'linear-gradient(to right, transparent via-[#F39A81] to-[#F39A81])',
  
  // Review status gradient
  reviewStatus: 'linear-gradient(to right, #F39A81, #959BEA)'
} as const;

// Gradient text styling utility
export const applyGradientText = (gradient: string) => ({
  background: gradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text'
});

// Border gradient styling utility
export const applyBorderGradient = (gradient: string = GRADIENTS.borderGradient) => ({
  background: gradient,
  border: '2px solid transparent'
});

// Common gradient component styles
export const GRADIENT_STYLES = {
  // Main title styling
  titleStyle: {
    ...applyGradientText(GRADIENTS.picassoPrimary),
    fontFamily: 'Museo',
    fontWeight: 600,
    leadingNone: true,
    trackingNormal: true
  },
  
  // Selected model button styling
  selectedModelStyle: {
    ...applyBorderGradient(),
    color: 'black',
    fontWeight: 'medium',
    height: '49px'
  },
  
  // Decorative circle styling
  decorativeCircle: {
    background: GRADIENTS.borderGradient,
    borderRadius: '50%',
    border: '2px solid transparent'
  }
} as const;
